import React, { Component } from 'react'
import { isEqual } from 'lodash'

// FIXME: toggling was implemented to meet the requirements of Gi Group Poland (workservice) layout
//        it is not the best idea for toggling whole gitem element, there should be shortcode for child elements, such as vc_toggable_post_content
//        but template required to modify vc_gitem className, and transfering it as props wasn't good idea too...
//        
//        this solution can cause unexpected errors
//
//        try to limit toggling only to VCGitems that realy needs it - maybe based on data-vc-class?


class VCGitem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toggle: false
    }
  }
  toggle = (e) => {
    // e.preventDefault()
    e.stopPropagation() // required if nested toggle
    if (e.target.tagName !== 'A')
      this.setState({ toggle: !this.state.toggle })
  }
  // FIXME: so, so bad solution for toggling off when component was updated (f.e.: when tab or pagination changed)
  //        isEqual on react object can be very slow...
  componentDidUpdate(prevProps, prevState) {
    if (this.state.toggle === true && !isEqual(this.props.children, prevProps.children)) {
      // console.log(this.props.children, prevProps.children)
      this.setState({toggle: false})
    }
  }
  render() {
    return (
      <div className={this.props.className + (this.state.toggle ? ' active' : '')} onClick={this.toggle}>{this.props.children}</div>
    )
  }
}

export default VCGitem


// WEBPACK FOOTER //
// ./src/components/VCGitem.js